/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies, ember/require-tagless-components */
import Component from '@ember/component';
import { set, get, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default class TopicCard extends Component {
  @service
  session;

  @service
  features;

  @service
  permissions;

  @service
  strings;

  // goal is the goal/topic to be displayed.
  goal = null;

  // group is the current group being worked on
  group = null;

  // Class is appended to the top level of the md-card
  class = '';

  @alias('features.sidekickEnabled')
  sidekickEnabled;

  goalLinkedGoals = [];
  groupedGoals = null;

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);

    // Wait for async data if necessary
    let linkedGoalIds = this.goal.get('linkedGoalIds');
    this._updateGroupedGoals(linkedGoalIds);
  }

  _updateGroupedGoals() {
    let groupedGoals = {};
    let linkedGoalIds = this.goal.get('linkedGoalIds') || [];

    linkedGoalIds.forEach((goal) => {
      if (goal) {
        // Safely access 'subjectId' and 'subjectTypeName' with `.get()`
        let subject = get(goal, 'subjectId');
        let subjectType = subject ? get(subject, 'subjectTypeName') : 0;

        // Initialize the array for this key if it doesn't exist yet
        if (!groupedGoals[subjectType]) {
          groupedGoals[subjectType] = 0;
        }
        // Increment the count for the corresponding key
        groupedGoals[subjectType]++;
      }
    });

    // Set the groupedGoals property
    set(this, 'groupedGoals', groupedGoals);
  }

  // showSidekickCode determines whether to display the Sidekick QR code.
  @computed('sidekickEnabled', 'goal.{subject.isTopic,linkedGoalIds.[]}')
  get showSidekickCode() {
    if (!this.sidekickEnabled) {
      // Never render Sidekick QR codes if Sidekick isn't enabled.
      return false;
    }
    if (this.isTopic) {
      // For Topics, only render the code if there are any linked goal IDs.
      return !isEmpty(this.goal.linkedGoalIds);
    }
    // For regular goals, render the code as long as Sidekick is enabled.
    return true;
  }
}
